/**
 * 编辑语音包
 */
import React from 'react';
import { Modal, Button } from 'antd';
import { XInput, } from '@/components/xqxc_ui';
import CusotmUpload, { generateFileList } from '@/components/NewUpload';
import PropTypes from 'prop-types';
import styles from './PackModal.module.scss';
import { message, Radio } from 'antd';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
// import model from '@/reducers/systemanage/parameter/model';


const RadioGroup = Radio.Group;

class Pack extends React.Component {

    constructor(props) {
        super(props);
        const { name, url, systemType, systemTypeValue } = props.data;
        this.state = {
            title: props.title,
            visible: props.visible,
            confirmLoading: false,
            packName: name || '',//语音名称
            singleImages: generateFileList(url) || [],//语音包 
            languageDuration: {},//语音包属性
            radioValue: systemType || 'RIDER_APP',
            // packCode: code || '',//编码
        };
    }

    componentDidMount() {

    }

    _handleOk = () => {
        const { singleImages, packName, languageDuration, radioValue, packCode } = this.state;
        const { id, } = this.props.data;
        if (packName == '') return message.warning('请输入语音名称');
        if (radioValue == '') return message.warning('请选择终端');
        if (packCode == '') return message.warning('请输入编码');
        if (singleImages.length === 0) return message.warning('请上传语音包');
        if (languageDuration.size / 1024 / 1024 > 2) {
            return message.warning('语音不能超过2M');
        }
        if (languageDuration.duration > 30) {
            return message.warning('语音时长不能超过30秒');
        }
        let submitData = {
            id,
            // name: packName,
            // application: radioValue,
            // code: packCode,
            url: singleImages[0].response ? singleImages[0].response.key : singleImages[0].url,
        };

        this.setState({ confirmLoading: true }, () => {
            http('/?cmd=com.xqxc.api.pig.mis.biz.platform.VoicePacketMisService.updateVoicePacket', submitData, 'POST')
                .then(() => {
                    message.success('更新成功');
                    this.setState({
                        visible: false,
                    });
                    this.props.closeMode(true);
                }).catch((e = {}) => {
                    this.setState({ confirmLoading: false });
                    message.error(e.message);
                });
        });
    }

    _handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }

    // Radio状态改变时触发
    _radioValueChangeHandle = (e) => {
        this.setState({ radioValue: e.target.value });
    }

    render() {
        const { visible, title, confirmLoading, packName, singleImages, radioValue, packCode } = this.state;
        const { data = {} } = this.props;
        const {
            systemType,
            systemTypeValue,
        } = data;
        return (
            <Modal
                width={470}
                centered
                title={title}
                visible={visible}
                confirmLoading={confirmLoading}
                onCancel={this._handleCancel}
                onOk={this._handleOk}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                okText='确定'
                cancelText='取消'
            >

                <div className={styles.container}>
                    <div className={`${styles.layout} ${styles.dataTop}`}>
                        <XInput
                            inputStyle={{ width: '270px' }}
                            label='语音名称'
                            placeholder='请输入语音名称'
                            value={packName}
                            isRequired={true}
                            readOnly={true}
                            bindThis={this}
                            bindName='packName'
                        />
                    </div>
                    {/* <div className={`${styles.layout} ${styles.dataTop}`}>
                        <XInput
                            inputStyle={{ marginLeft: '27px', width: '270px' }}
                            label='编码'
                            placeholder='请输入编码'
                            value={packCode}
                            isRequired={true}
                            bindThis={this}
                            bindName='packCode'
                            readOnly={true}
                        />
                    </div> */}
                    <div className={styles.radio}>
                        <div className={styles.label}><i>*</i>终端</div>
                        <RadioGroup disabled={true} style={{ marginLeft: '12px' }} onChange={this._radioValueChangeHandle} value={radioValue}>
                           <Radio key={systemType} value={systemType}>{systemTypeValue}</Radio>
                        </RadioGroup>
                    </div>
                    <div className={`${styles.Upload} ${styles.layout}`}>
                        <span className={styles.icon}><i>*</i>语音包</span>
                        <CusotmUpload
                            accept='.mp3,.wav,.pcm,.m4a,.wma'
                            fileList={singleImages}
                            returnAudioDuration
                            wallMode="single"
                            removeError
                            qiniuUploadProps={{
                                uploadType: 'image'
                            }}
                            onChange={(info) => {
                                const pack = info.fileList.length > 1 ? [info.fileList.pop()] : info.fileList;
                                this.setState({
                                    singleImages: pack
                                });
                            }}
                            beforeUpload={file => {
                                const isType = ['audio/x-m4a', 'audio/x-mp3', 'audio/mp3', 'audio/mpeg'];
                                if (!isType.includes(file.type)) {
                                    message.warning('只能上传 .mp3,.wav,.pcm,.m4a,.wma 格式的文件!');
                                    file.status = 'error';
                                    return false;
                                }
                            }}
                            onFileListChange={(info, customFile) => {//audio/x-m4a,audio/x-mp3,"audio/mp3"
                                if (customFile && customFile.status === 'success') {
                                    const { duration = {}, size } = customFile;
                                    let properties = {
                                        duration: duration.duration,//时长/秒
                                        size//大小
                                    };
                                    this.setState({ languageDuration: properties });
                                }
                                if (!customFile || (customFile && customFile.status === 'error')) {
                                    this.setState({ languageDuration: {} });
                                }
                            }}
                        >
                            <Button icon="upload">上传语音包</Button>
                        </CusotmUpload>
                    </div>
                    <p className={styles.ps}>当前仅支持mp3、wav、pcm、m4a、wma格式,单条音频不能超过2M且时长不能超过30秒。</p>
                </div>
            </Modal>
        );
    }
}

Pack.propTypes = {
    title: PropTypes.string,// 弹框标题
    data: PropTypes.object, //数据
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
};


const mapStateToProps = (state) => ({
});


export default connect(mapStateToProps)(Pack);
